module.exports = __webpack_public_path__ + "img/Deposit.af5319e6.svg";